<template>
  <div>
    <span class="biaoti">余额明细</span>
    <el-form
      ref="form"
      :model="so"
      label-width="80px"
      style="background: #FFFFFF; padding: 20px 20px 20px 120px;"
    >
      <el-form-item label="使用时间">
        <el-date-picker
       		v-model="so.shijian"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期" 
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="会员信息">
        <el-input v-model="so.guanjianci" placeholder="可搜索姓名/昵称/手机号"></el-input>
      </el-form-item>
	  <el-form-item label="会员ID">
	    <el-input v-model="so.hyid" placeholder="可搜索会员ID"></el-input>
	  </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model="so.dingdanhao" placeholder="订单号"></el-input>
      </el-form-item>
      <el-form-item label="说明">
        <el-input v-model="so.shuoming" placeholder="说明"></el-input>
      </el-form-item>
  <!--    <el-form-item label="类型">
			<el-select v-model="so.leixing" placeholder="请选择">
				<el-option v-for="l in leixing" :label="l.ming" :value="l.zhi"></el-option>
			</el-select>
      </el-form-item> -->
     <!-- <el-form-item label="状态">
        <el-select v-model="so.zhuangtai" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label>
        <el-button type="primary" size="small"  @click="CSH">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <el-table :data="shu.lie" style="width: 100%">
      <el-table-column prop="shijian" label="时间"></el-table-column>
      <el-table-column prop="huiyuan_id" label="会员ID"></el-table-column>
	    <el-table-column prop="nicheng" label="会员昵称"></el-table-column>
      <el-table-column prop="zhi" label="额度"></el-table-column>
	   <el-table-column prop="dingdanhao" label="订单号"></el-table-column>
	   <el-table-column prop="zhifuqudao" label="支付渠道">
		   <template slot-scope="shu">
			   <el-button size="small" v-if="shu.row.zhifuqudao=='weixin' || shu.row.zhifuqudao=='xiaochengxu'" type="success">微信支付</el-button>
			   <el-button size="small" v-else-if="shu.row.zhifuqudao=='fulika' || shu.row.zhifuqudao==null" type="success">福利卡支付</el-button>
		   </template>
	   </el-table-column>
	   
      <el-table-column prop="shuoming" label="说明"></el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev,pager,next,jumper"
      :total="zongshu"
      :page-size="jitiao"
      :current-page.sync="ye"
      @current-change="CSH"
      style="margin-top: 30px;"
    />
  </div>
</template>

<script>
var that;
export default {
  data() {
    return {
      ye: 1,
      jitiao: 20,
      shu: {
        lie: [],
        zongshu: 0
      },
	  zongshu:0,
      so: {zhuangtai:''},
      options: [{ label: "不限", value: "" },{ label: "待到账", value: "0" },{ label: "已到账", value: "1" }],
	  leixing:[
		  {zhi:'',ming:"不限"},
		  {zhi:1,ming:"在线充值"},
		  {zhi:2,ming:"分享佣金"},
		  {zhi:3,ming:"销售收入"},
		  {zhi:4,ming:"团队收益"},
		  {zhi:5,ming:"后台充值"},		
		  {zhi:6,ming:"核销收益"},
		  ]
	}
  },
  created() {
    that = this;
    this.CSH();
  },
  methods: {
    CSH() {
      that.so.ye = that.ye;
      that.so.jitiao = that.jitiao;
	  that.so.weixinjilu=0
      that.$post("k=huiyuan&c=Fulikajilu", that.so, function(s) {
        that.shu = s.shu;
		that.zongshu=Number(s.shu.zongshu);
      });
    }
  }
};
</script>

<style>
.biaoti {
  display: block;
  width: 100%;
  text-indent: 10px;
  margin-bottom: 16px;
  font-size: 20px;
  color: #788188;
}
</style>
